var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"xl:col-span-8 text-center"},[_c('step-title',{attrs:{"title":'Lisad'}}),_c('div',{staticClass:"md:max-w-lg mx-auto"},[_c('StepFourHexagonGrid')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }